import React from 'react';
import MainRoutes from './utils/main.routes';

const App = (props) => {
	return <MainRoutes></MainRoutes>;
};

export default App;
